import { useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import {
  HOLDING_BACK_OPTIONS,
  HOLDING_BACK_QUESTION,
} from '~/pages/communication/holdingBack/libs/components/HoldingBackCommunication/constants'
import { CommunicationMultiSelectStyles as S } from '~/pages/communication/libs/communicationMultiSelectStyles'
import { parseEmojiOption } from '~/pages/communication/libs/parseEmojiOption'
import { useNextStep } from '~/shared/hooks/useNextStep'
import { eventLogger } from '~/shared/services/eventLogger'
import { TPageProps } from '~/shared/types/commonTypes'

const HoldingBackCommunication = ({ nextPagePath, pageId }: TPageProps) => {
  const { t } = useTranslation('communication')
  const [answers, setAnswers] = useState<string[]>([])

  const handleContinue = useNextStep({
    nextPagePath,
    pageId,
    pageName: pageId,
    question: HOLDING_BACK_QUESTION,
  })

  const handleOptionToggle = (key: string) => {
    setAnswers((prev) =>
      prev.includes(key) ? prev.filter((a) => a !== key) : [...prev, key],
    )
  }

  return (
    <S.Root>
      <S.ContentWrapper>
        <S.ScrollContent>
          <S.TitleGroup>
            <S.Title>
              <Trans
                ns="communication"
                i18nKey="onboarding.communicationHoldingBack.title"
              />
            </S.Title>
            <S.Subtitle>
              <Trans
                ns="communication"
                i18nKey="onboarding.communicationHoldingBack.subtitle"
              />
            </S.Subtitle>
          </S.TitleGroup>

          <S.Options>
            {HOLDING_BACK_OPTIONS.map(({ key, i18nKey }) => {
              const isSelected = answers.includes(key)
              const { emoji, label } = parseEmojiOption(
                t(`onboarding.communicationHoldingBack.options.${i18nKey}`),
              )

              return (
                <S.OptionButton
                  key={key}
                  type="button"
                  $isSelected={isSelected}
                  onClick={() => handleOptionToggle(key)}
                >
                  <S.OptionEmoji>{emoji}</S.OptionEmoji>
                  <S.OptionLabel>{label}</S.OptionLabel>
                  <S.Checkbox $isSelected={isSelected} />
                </S.OptionButton>
              )
            })}
          </S.Options>
        </S.ScrollContent>

        <S.ButtonWrapper>
          <S.Button
            type="button"
            disabled={!answers.length}
            onClick={() => {
              eventLogger.logBiUserGoal(answers)
              handleContinue(answers)
            }}
          >
            <Trans i18nKey="actions.continue" />
          </S.Button>
        </S.ButtonWrapper>
      </S.ContentWrapper>
    </S.Root>
  )
}

export default HoldingBackCommunication
